module.exports = __webpack_public_path__ + "img/position_tip.dc277d1e.png";